// Define constants for WhiteLabelSourceTypeId
export const WhiteLabelSourceTypeId = {
  AGENT_INTERNAL: 1,
  AGENT_EXTERNAL: 2,
  MAIN_SITE: 3
};

// Define constants for Cookies
export const Cookie = {
  MICROSITE_COOKIE: 'MicrositeCookie'
};
